import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {scopes, resources} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {Link} from 'react-router-dom';
import {Container, Card, Grid, Button, Tab, Dimmer, Loader} from 'semantic-ui-react';
import CombosListTable from './combosListTable';
import {getColumns} from './combosListColumns';
import ExcelReader from '../../../excelReader/components/index';
import './styles.scss';

const {
  navigateTo,
  fecthCombosList,
  cleanCombosList,
  uploadComboExcel,
} = Actions;

const Index = () => {
  const permissions = useSelector((state) => state.session.permissions);
  const loading = useSelector((state) => state.combos.loading);
  const combosList = useSelector((state) => state.combos.list);
  const [tabActives, setTabActives] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.CombosManagement, scopes.See) &&
     !hasAccessPermission(permissions, resources.CombosManagement, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(fecthCombosList());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fecthCombosList());
  }, [tabActives]);

  const getChangeStatePermissions = () => {
    if (hasAccessPermission(permissions, resources.CombosManagement, scopes.Edit)) {
      return true;
    }
    return false;
  };

  const handleTabChange = (e, tab) => {
    e.preventDefault();
    tab.activeIndex === 0 ? setTabActives(true) : setTabActives(false);
    dispatch(cleanCombosList());
  };

  const formatTransferDetail = (data) => {
    return data.map((item) => ({'code': item[0], 'description': item[1], 'installType': item[2], 'partCode': item[3],
      'quantity': item[4], 'price': item[5]}));
  };
  
  const loadFile = (data) => {
    const detail = formatTransferDetail(data);
    dispatch(uploadComboExcel(detail));
  };

  const columns = getColumns(getChangeStatePermissions);
  
  const renderCombosListTable = () => {
    return <Tab.Pane>
      {
        combosList ?
          <div>
            <Card raised fluid>
              {loading &&
                <Dimmer active inverted>
                  <Loader inverted />
                </Dimmer>
              }
              <CombosListTable tableColumns={columns}
                tableData={tabActives ? combosList.filter((x) => x.status === 'A') :
                  combosList.filter((x) => x.status === 'I')} />
            </Card>
          </div> :
          ''
      }
    </Tab.Pane>;
  };

  return (
    <Container fluid>
      <Card raised fluid style={{'backgroundColor': 'transparent'}}>
        <div className='title-bar'>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <div className='title'>
                  <h2>Administración de Combos</h2>
                </div>
              </Grid.Column>
              <Grid.Column textAlign='right'>
                {getChangeStatePermissions() ?
                  <>
                    <ExcelReader onGetFile={loadFile} text='IMPORTAR' />
                    <Link to={paths.ComboCreate}>
                      <Button primary>CREAR</Button>
                    </Link>
                  </> : ''
                }
                <Link to={paths.CombosByKatashikies}>
                  <Button primary>VISTA POR KATASHIKIES</Button>
                </Link>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Card>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Tab onTabChange={(e, value) => handleTabChange(e, value)} panes={[
              {'menuItem': 'ACTIVOS', 'render': () => renderCombosListTable()},
              {'menuItem': 'INACTIVOS', 'render': () => renderCombosListTable()},
            ]}></Tab>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};

export default Index;
